import { render, staticRenderFns } from "./groMoregameMg.vue?vue&type=template&id=9573d242&scoped=true&"
import script from "./groMoregameMg.vue?vue&type=script&lang=js&"
export * from "./groMoregameMg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9573d242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9573d242')) {
      api.createRecord('9573d242', component.options)
    } else {
      api.reload('9573d242', component.options)
    }
    module.hot.accept("./groMoregameMg.vue?vue&type=template&id=9573d242&scoped=true&", function () {
      api.rerender('9573d242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/groMore/groMoregameMg.vue"
export default component.exports